<template>
  <section
    class="flex items-center justify-center font-manrope"
    role="status"
    aria-live="polite"
  >
    <div class="relative w-full max-w-2xl">
      <div class="flex flex-col items-center justify-center relative">
        <div class="h-12 w-12 rounded-full bg-white border border-gray-200  flex items-center justify-center">
          🌟
        </div>
        <div class="flex flex-col items-center justify-center px-2 pt-6 pb-6 text-center">
          <h2 class="font-poppins text-xl font-semibold text-slate-900">
            It's almost showtime
          </h2>
          <p class="mt-2 text-sm leading-6 text-slate-600">
            Get everything ready in a few steps and kick off the discussion.
          </p>
          <ol class="flex items-center text-left mt-5 space-x-4">
            <li class="flex items-center">
              <i class="fa-solid fa-circle-check text-lg text-green-600"></i>
              <div class="ml-3">
                <div class="text-sm font-semibold text-slate-800">
                  1. <button @click="goToPromptTab" class="hover:underline">Create Prompt</button>
                </div>
              </div>
            </li>

            <li class="flex items-center">
              <i class="fa-solid fa-circle-check text-lg text-green-600"></i>
              <div class="ml-3">
                <div class="text-sm font-semibold text-slate-800">
                  2. <button @click="goToSettingsTab" class="hover:underline">Choose Settings</button>
                </div>
              </div>
            </li>

            <li class="flex items-center">
              <i v-if="students_invited" class="fa-solid fa-circle-check text-lg text-green-600 mt-0.5"></i>
              <i v-else class="far fa-circle text-lg text-slate-400"></i>
              <div class="ml-3">
                <div class="text-sm font-semibold text-slate-800">
                  3. <button @click="inviteStudents" class="hover:underline">Invite Students</button>
                </div>
              </div>
            </li>

            <li v-if="roundtable.type === 'verbal'" class="flex items-center">
              <i class="far fa-circle text-lg text-slate-400"></i>
              <div class="ml-3">
                <div class="text-sm font-semibold text-slate-800">
                  4. <button @click="startDiscussion" class="hover:underline">Start Discussion</button>
                </div>
              </div>
            </li>
          </ol>

          <div @click="howItWorks" class="mt-6 text-sm text-gray-800 font-manrope cursor-pointer hover:underline">
            How does this work?
          </div>
        </div>

        <div class="h-px bg-slate-100"></div>
      </div>
    </div>
  </section>

</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {};
    },
    props: {
      roundtable: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getSubmissionsBySubmitStatus',
      ]),
      students_invited() {
        if (this.roundtable.type === 'written') {
          return (
            (this.getSubmissionsBySubmitStatus.not_submitted.length ||
              this.getSubmissionsBySubmitStatus.submitted.length ||
              this.getSubmissionsBySubmitStatus.by_passed.length) !== 0
          );
        } else if (this.roundtable.type === 'verbal') {
          return this.roundtable.participations.length > 0;
        }
        return false;
      },
    },
    methods: {
      goToPromptTab() {
        EventBus.$emit('handleTab', 'prompt');
      },
      goToSettingsTab() {
        EventBus.$emit('handleTab', 'settings');
      },
      inviteStudents() {
        EventBus.$emit('openInviteStudentsModal');
      },
      startDiscussion() {
        EventBus.$emit('startDiscussion');
      },
      howItWorks() {
        EventBus.$emit('showRountableWelcomeModal');
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';
  .placeholder
    background: rgba(226, 232, 240, 1);
    &:last-child
      width: 80%;
  .written-background-image
    background-image: url("~/static/online_roundtable_icons/blank_submissions.svg");
  .verbal-background-image
    background-image: url("~/static/live_discussion/blank_participations.svg");
</style>



// WEBPACK FOOTER //
// checklist.vue?8a4fbf5c